<template>
  <div v-if="session">
    <div class="row mb-4">
      <div class="col-md-3">
        <div class="card border-0 bg-light">
          <div class="card-body text-center">
            <h3 class="fw-bold mb-1">{{ session.totals.input }}</h3>
            <p class="text-muted mb-0">Inputs</p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-light">
          <div class="card-body text-center">
            <h3 class="fw-bold text-success mb-1">{{ session.totals.processed }}</h3>
            <p class="text-muted mb-0">Processed</p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-light">
          <div class="card-body text-center">
            <h3 class="fw-bold text-warning mb-1">{{ session.totals.conflict }}</h3>
            <p class="text-muted mb-0">Conflict</p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card border-0 bg-light">
          <div class="card-body text-center">
            <h3 class="fw-bold text-danger mb-1">{{ session.totals.failed }}</h3>
            <p class="text-muted mb-0">Failed</p>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex gap-2 mb-3">
      <button class="btn btn-outline-secondary" @click="exportAll">Export All (CSV)</button>
      <button class="btn btn-outline-success" @click="exportBucket('processed')">
        Export Processed
      </button>
      <button class="btn btn-outline-warning" @click="exportBucket('conflict')">
        Export Conflicts
      </button>
      <button class="btn btn-outline-danger" @click="exportBucket('failed')">Export Failed</button>
    </div>

    <div v-for="bucket in buckets" :key="bucket" class="mb-4">
      <h5 class="fw-bold text-capitalize">{{ bucket }} ({{ groupedItems[bucket].length }})</h5>
      <div v-if="groupedItems[bucket].length === 0" class="text-muted">None</div>
      <table v-else class="table table-hover">
        <thead class="table-light">
          <tr>
            <th>Order UUID</th>
            <th>Order State</th>
            <th>Partner</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in groupedItems[bucket]" :key="item.orderUuid">
            <td class="font-monospace small">{{ item.orderUuid }}</td>
            <td>{{ item.orderState ?? '-' }}</td>
            <td>{{ item.partnerName ?? '-' }}</td>
            <td>{{ item.reason ?? '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { AssignmentSession } from '../composables/useAssignmentSession';
import { exportSession } from '../composables/useAssignmentCsv';

const props = defineProps<{ session: AssignmentSession | null }>();

const buckets = ['processed', 'conflict', 'failed'] as const;
const groupedItems = computed(() => ({
  processed: props.session?.items.filter((i) => i.result === 'processed') ?? [],
  conflict: props.session?.items.filter((i) => i.result === 'conflict') ?? [],
  failed: props.session?.items.filter((i) => i.result === 'failed') ?? [],
}));

function exportAll() {
  if (props.session) exportSession(props.session);
}
function exportBucket(b: 'processed' | 'conflict' | 'failed') {
  if (props.session) exportSession(props.session, b);
}
</script>

<style scoped>
.font-monospace {
  font-family: 'Courier New', Courier, monospace;
}
</style>
